import React from 'react';
import Box from "@mui/material/Box";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MooringmateFAQ = () => {

  return (
		<>
			<Box data-lang="en">
				<h3 class="subtitle">EN (English)</h3>
				<Accordion defaultExpanded>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography component="span">How does renting or swapping a berth work?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li>Search by port or area</li>
							<li>View berth availability and details</li>
							<li>Reserve or send a swap request</li>
							<li>Wait for confirmation from the owner</li>
							<li>Once approved, an automatic email is sent to the port office including all relevant information such as registration, insurance, passport details, and the rental or swap period</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
					>
						<Typography component="span">Can I swap a berth without any payment?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Yes, you can choose a free-of-charge swap based on mutual agreement and confirmation between both parties.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel3-content"
						id="panel3-header"
					>
						<Typography component="span">What information is shown for each berth?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<p>Each berth listing includes:</p>
						<ul style={{ margin: '0' }}>
							<li>A port layout map</li>
							<li>Working VHF channels</li>
							<li>Water depth in the port and at the berth</li>
							<li>Available facilities (such as water, electricity, Wi-Fi)</li>
							<li>Shore power type (connection)</li>
							<li>Height of the dock</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel4-content"
						id="panel4-header"
					>
						<Typography component="span">Is my booking confirmed immediately after the request?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						No. The berth owner must first approve your request. The booking is only confirmed after their approval.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel5-content"
						id="panel5-header"
					>
						<Typography component="span">How does cancellation work?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li><strong>Less than 48 hours before the rental or swap period starts :</strong> No refund</li>
							<li><strong>More than 48 hours in advance :</strong> 20% cancellation fee will be deducted from the original amount</li>
						</ul>
					</AccordionDetails>
				</Accordion>
			</Box>
			<Box data-lang="es" sx={{ display: 'none' }}>
				<h3 class="subtitle">ES (Español)</h3>
				<Accordion defaultExpanded>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography component="span">¿Cómo funciona el alquiler o intercambio de un amarre?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li>Busca por puerto o zona</li>
							<li>Consulta la disponibilidad y los detalles del amarre</li>
							<li>Reserva o envía una solicitud de intercambio</li>
							<li>Espera la confirmación del propietario</li>
							<li>Una vez aprobado, se envía automáticamente un correo electrónico a la oficina del puerto con toda la información relevante, como registro, seguro, datos del pasaporte y el período de alquiler o intercambio</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
					>
						<Typography component="span">¿Puedo intercambiar un amarre sin pagar?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Sí, puedes optar por un intercambio gratuito basado en el acuerdo y la confirmación mutua entre ambas partes.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel3-content"
						id="panel3-header"
					>
						<Typography component="span">¿Qué información se muestra para cada amarre?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<p>Cada anuncio de amarre incluye:</p>
						<ul style={{ margin: '0' }}>
							<li>Un plano del puerto</li>
							<li>Canales VHF operativos</li>
							<li>Profundidad del agua en el puerto y en el amarre</li>
							<li>Instalaciones disponibles (como agua, electricidad, Wi-Fi)</li>
							<li>Tipo de conexión de energía en tierra</li>
							<li>Altura del muelle</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel4-content"
						id="panel4-header"
					>
						<Typography component="span">¿Mi reserva se confirma inmediatamente después de la solicitud?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						No. El propietario del amarre debe aprobar tu solicitud primero. La reserva solo se confirma tras su aprobación.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel5-content"
						id="panel5-header"
					>
						<Typography component="span">¿Cómo funciona la cancelación?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li><strong>Menos de 48 horas antes del inicio del alquiler o intercambio: </strong> No hay reembolso</li>
							<li><strong>Más de 48 horas de antelación: </strong> Se aplica una tarifa de cancelación del 20% sobre el importe original</li>
						</ul>
					</AccordionDetails>
				</Accordion>
			</Box>
			<Box data-lang="fr" sx={{ display: 'none' }}>
				<h3 class="subtitle">FR (Français)</h3>
				<Accordion defaultExpanded>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography component="span">Comment fonctionne la location ou l’échange d’une place d’amarrage?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li>Recherchez par port ou région</li>
							<li>Consultez la disponibilité et les détails de la place</li>
							<li>Réservez ou envoyez une demande d’échange</li>
							<li>Attendez la confirmation du propriétaire</li>
							<li>Une fois approuvée, un e-mail automatique est envoyé à la capitainerie avec toutes les informations nécessaires : immatriculation, assurance, passeports et durée de la location ou de l’échange</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
					>
						<Typography component="span">Puis-je échanger une place sans paiement?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Oui, vous pouvez choisir un échange gratuit basé sur un accord et une confirmation mutuels entre les deux parties.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel3-content"
						id="panel3-header"
					>
						<Typography component="span">Quelles informations sont affichées pour chaque place d’amarrage?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<p>Chaque annonce inclut :</p>
						<ul style={{ margin: '0' }}>
							<li>Un plan du port</li>
							<li>Les canaux VHF utilisés</li>
							<li>La profondeur d’eau dans le port et au niveau de la place</li>
							<li>Les équipements disponibles (eau, électricité, Wi-Fi)</li>
							<li>Le type de branchement pour l’alimentation à quai</li>
							<li>La hauteur du quai</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel4-content"
						id="panel4-header"
					>
						<Typography component="span">Ma réservation est-elle confirmée dès l’envoi de la demande?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Non. Le propriétaire de la place doit d’abord approuver votre demande. La réservation n’est confirmée qu’après son approbation.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel5-content"
						id="panel5-header"
					>
						<Typography component="span">Comment fonctionne l’annulation ?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li><strong>Moins de 48 heures avant le début de la période de location ou d’échange : </strong> Aucun remboursement</li>
							<li><strong>Plus de 48 heures à l’avance : </strong> Des frais d’annulation de 20 % seront appliqués sur le montant initial</li>
						</ul>
					</AccordionDetails>
				</Accordion>
			</Box>
			<Box data-lang="nl" sx={{ display: 'none' }}>
				<h3 class="subtitle">NL (Nederlands)</h3>
				<Accordion defaultExpanded>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography component="span">Hoe werkt het huren of swappen van een ligplaats?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li>Zoek op haven of gebied</li>
							<li>Bekijk beschikbaarheid en details van de ligplaats</li>
							<li>Reserveer of dien een verzoek tot swap in</li>
							<li>Wacht op bevestiging van de eigenaar</li>
							<li>Na goedkeuring wordt automatisch een e-mail verstuurd naar het havenkantoor met alle relevante informatie, waaronder registratie, verzekering, paspoortgegevens en de huur- of swapperiode</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
					>
						<Typography component="span">Kan ik ook alleen ruilen zonder betaling?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Ja, je kunt kiezen voor een kosteloze swap op basis van wederzijds akkoord en bevestiging tussen beide partijen.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel3-content"
						id="panel3-header"
					>
						<Typography component="span">Welke informatie is zichtbaar bij elke ligplaats?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<p>Bij elke ligplaats zie je:</p>
						<ul style={{ margin: '0' }}>
							<li>Een havenplattegrond</li>
							<li>Werkkanalen (VHF)</li>
							<li>Diepgang in de haven én op de specifieke plek</li>
							<li>Faciliteiten (zoals water, stroom, wifi)</li>
							<li>Type walstroom (aansluiting)</li>
							<li>Hoogte van de steiger</li>
						</ul>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel4-content"
						id="panel4-header"
					>
						<Typography component="span">Is mijn boeking definitief na aanvraag?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						Nee. De eigenaar van de ligplaats moet jouw aanvraag eerst goedkeuren. Pas na bevestiging is de boeking definitief.
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel5-content"
						id="panel5-header"
					>
						<Typography component="span">Hoe werkt annuleren?</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<ul style={{ margin: '0' }}>
							<li><strong>Minder dan 48 uur vóór de aanvang van de huur- of swapperiode :</strong> Geen restitutie</li>
							<li><strong>Meer dan 48 uur vóór aanvang :</strong> Er wordt 20% annuleringskosten gerekend over het oorspronkelijke bedrag</li>
						</ul>
					</AccordionDetails>
				</Accordion>
			</Box>
		</>
  );
};
